import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from 'src/app/shared/icon/icon.module';

@Component({
  selector: 'app-restore-confirm-modal',
  standalone: true,
  imports: [CommonModule, IconModule],
  template: `
    <div
      *ngIf="open"
      class="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 px-4"
      (click)="onBackdrop()"
    >
      <div
        class="relative w-full max-w-sm rounded-2xl bg-white dark:bg-[#0e1726] shadow-xl p-6"
        (click)="$event.stopPropagation()"
      >
        <div class="mb-4 flex justify-center">
          <div class="flex h-14 w-14 items-center justify-center rounded-full bg-[#FFD85F]/30">
            <icon-restore class="size-7 text-[#18214d] dark:text-[#FFD85F]" />
          </div>
        </div>
        <h3 class="text-center text-base font-semibold text-[#18214d] dark:text-white mb-1">
          {{ heading }}
        </h3>
        <p class="text-center text-sm text-gray-500 dark:text-gray-400 mb-6">
          Restore <strong>{{ entityName }}</strong> to the {{ activeListLabel }}?
        </p>
        <div class="flex gap-3">
          <button
            type="button"
            (click)="onCancel()"
            class="flex-1 rounded-lg border border-gray-200 dark:border-[#191e3a] py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-white/5"
          >
            Cancel
          </button>
          <button
            type="button"
            (click)="onConfirm()"
            [disabled]="loading"
            class="flex-1 rounded-lg bg-[#FFD85F] py-2 text-sm font-medium text-black hover:bg-[#f0cc58] disabled:opacity-60 dark:bg-[#e8c44a] dark:hover:bg-[#d9b63f]"
          >
            <span *ngIf="!loading">Restore</span>
            <span *ngIf="loading">Restoring…</span>
          </button>
        </div>
      </div>
    </div>
  `,
})
export class RestoreConfirmModalComponent {
  @Input() open = false;
  @Input() heading = 'Restore?';
  @Input() entityName = '';
  @Input() activeListLabel = 'active list';
  @Input() loading = false;

  @Output() cancelled = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();

  onBackdrop(): void {
    this.cancelled.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  onConfirm(): void {
    this.confirmed.emit();
  }
}
